import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import { Redux } from '../..'
import { GygQueryOptions } from '@/src/views/components/master-pricing-list/types'

interface PosMenuConfiguration {
  id: number
  name: string
  posMenuId: number
  description: string
  url: string
  apiKey: string
  createdAt: string
  createdBy: number
  updatedAt: number | null
  updatedBy: number | null
  posMenu: {
    id: number
    name: string
  }
}

interface PosMenuConfigurationInitialState {
  posMenuConfigurations?: PosMenuConfiguration[] | null
  loading: boolean
  success: string | null
  error: string | null
}

const initialState: PosMenuConfigurationInitialState = {
  posMenuConfigurations: null,
  loading: false,
  success: null,
  error: null
}

interface PosMenuConfigurationResponse {
  data: PosMenuConfiguration[]
}

export const getPosMenuConfigurations = createAsyncThunk<PosMenuConfigurationResponse, GygQueryOptions, Redux>(
  'gygPosMenuConfiguration/getAllPosMenuConfigurations',
  async (gygQueryOptions, { extra }) => {
    const { data: responseData } = await extra.httpClient.get(`pos-menu-configurations`, { params: gygQueryOptions })

    return responseData
  }
)

const gygPosMenuConfigurationSlice = createSlice({
  name: 'getPosMenuConfigurations',
  initialState,
  reducers: {},
  extraReducers: builder => {
    builder
      .addCase(getPosMenuConfigurations.pending, state => {
        state.loading = true
        state.error = null
      })
      .addCase(getPosMenuConfigurations.fulfilled, (state, action) => {
        state.loading = false
        state.success = null
        state.posMenuConfigurations = action.payload.data
      })
      .addCase(getPosMenuConfigurations.rejected, (state, action) => {
        state.loading = false
        state.error = action.error.message ?? 'Failed to fetch pos menu configuration'
      })
  }
})

export default gygPosMenuConfigurationSlice.reducer
